<div class="options-menu-container">
  <div class="options-list">
    @for (option of options; track option) {
      <div class="option-item" (click)="selectOption(option)">
        <div class="option-card">
          @if (option.presentationData?.iconUrl) {
            <div class="option-icon">
              <img [src]="option.presentationData!.iconUrl" [alt]="option.description">
            </div>
          }
          <span class="option-name" [innerHTML]="getDisplayContent(option) | safeHtml"></span>
        </div>
      </div>
    }
  </div>
</div>